/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ExploreInputs */

const id_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi`)
};

const ms_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai`)
};

const da_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk`)
};

const de_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erkunden`)
};

const en_us2_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const es_es2_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const es_mx2_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const fil_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galugarin`)
};

const fr_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer`)
};

const it_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora`)
};

const hu_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felfedezés`)
};

const nl_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdekken`)
};

const no_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk`)
};

const pl_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkrywaj`)
};

const pt_br2_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const pt_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const ro_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorare`)
};

const fi_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutki`)
};

const sv_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska`)
};

const vi_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá`)
};

const tr_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keşfet`)
};

const cs_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumat`)
};

const bg_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разгледайте`)
};

const ru_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исследовать`)
};

const uk_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд`)
};

const ar_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشاف`)
};

const hi_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सप्लोर करें`)
};

const th_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำรวจ`)
};

const ja_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const zh_cn2_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const zh_hant1_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const ko_nav_explore = /** @type {(inputs: Nav_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탐색`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Nav_ExploreInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_explore = /** @type {((inputs?: Nav_ExploreInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ExploreInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_explore(inputs)
	if (locale === "ms") return ms_nav_explore(inputs)
	if (locale === "da") return da_nav_explore(inputs)
	if (locale === "de") return de_nav_explore(inputs)
	if (locale === "en-US") return en_us2_nav_explore(inputs)
	if (locale === "es-ES") return es_es2_nav_explore(inputs)
	if (locale === "es-MX") return es_mx2_nav_explore(inputs)
	if (locale === "fil") return fil_nav_explore(inputs)
	if (locale === "fr") return fr_nav_explore(inputs)
	if (locale === "it") return it_nav_explore(inputs)
	if (locale === "hu") return hu_nav_explore(inputs)
	if (locale === "nl") return nl_nav_explore(inputs)
	if (locale === "no") return no_nav_explore(inputs)
	if (locale === "pl") return pl_nav_explore(inputs)
	if (locale === "pt-BR") return pt_br2_nav_explore(inputs)
	if (locale === "pt") return pt_nav_explore(inputs)
	if (locale === "ro") return ro_nav_explore(inputs)
	if (locale === "fi") return fi_nav_explore(inputs)
	if (locale === "sv") return sv_nav_explore(inputs)
	if (locale === "vi") return vi_nav_explore(inputs)
	if (locale === "tr") return tr_nav_explore(inputs)
	if (locale === "cs") return cs_nav_explore(inputs)
	if (locale === "bg") return bg_nav_explore(inputs)
	if (locale === "ru") return ru_nav_explore(inputs)
	if (locale === "uk") return uk_nav_explore(inputs)
	if (locale === "ar") return ar_nav_explore(inputs)
	if (locale === "hi") return hi_nav_explore(inputs)
	if (locale === "th") return th_nav_explore(inputs)
	if (locale === "ja") return ja_nav_explore(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_explore(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_explore(inputs)
	return ko_nav_explore(inputs)
});
export { nav_explore as "nav.explore" }